module.exports = __webpack_public_path__ + "static/img/wood21.0810bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood21.jpg
// module id = CIXx
// module chunks = 0